document.addEventListener('DOMContentLoaded', () => {
    initShowMoreBooks();
    initShowMoreInfo();
});

function initShowMoreBooks() {
    const button = document.getElementById('show-more-author-books') as HTMLButtonElement;
    const section = document.getElementById('more-author-books-section') as HTMLElement;
    
    if (!button || !section) return;
    
    button.addEventListener('click', () => {
        const textSpan = button.querySelector('.txt') as HTMLSpanElement;
        const hideText = button.dataset.hidetext;
        
        if (textSpan && hideText) {
            const currentText = textSpan.textContent?.trim();
            textSpan.textContent = hideText;
            button.dataset.hidetext = currentText || '';
            
            const isHidden = section.classList.toggle('hidden');
            button.setAttribute('aria-expanded', (!isHidden).toString());
        }
    });
}

function initShowMoreInfo() {
    const button = document.getElementById('author-show-more-info-button') as HTMLButtonElement;
    const content = document.querySelector('.author-specifics') as HTMLElement;
    
    if (!button || !content) return;
    
    // Measure full content height
    content.classList.remove('closed');
    const fullHeight = content.scrollHeight;
    
    if (fullHeight > 250) {
        // Content exceeds 250px - enable show/hide functionality
        content.classList.add('closed');
        
        button.addEventListener('click', () => {
            const isClosed = content.classList.toggle('closed');
            const lessInfoText = button.dataset.lessinfotext;
            
            if (lessInfoText) {
                const currentText = button.textContent?.trim();
                button.textContent = lessInfoText;
                button.dataset.lessinfotext = currentText || '';
            }
        });
    } else {
        // Content fits within 250px - hide button
        button.style.display = 'none';
    }
}
